import React from 'react';
import './AutoplayModal.css';

import { Text, Grid, Button } from "@geist-ui/core";

const AutoplayModal = ({ onChoice }) => {
  return (
    <div className="autoplay-modal">
      <div className="autoplay-modal-content">
        <Text h2>Audio Playback Preference</Text>
        <Text p>Would you like to enable autoplay for audio narration?</Text>

        <Grid.Container gap={1.5}>
          <Grid><Button onClick={() => onChoice(true)} className="theme-button theme-button--w100"><Text span>Yes, enable autoplay</Text></Button></Grid>
          <Grid><Button onClick={() => onChoice(false)} className="theme-button theme-button--w100"><Text span>No, I'll play manually</Text></Button></Grid>
        </Grid.Container>
      </div>
    </div>
  );
};

export default AutoplayModal;